"use strict";
exports.__esModule = true;
exports.GET_CREDENTIALS = void 0;
var tslib_1 = require("tslib");
var react_1 = require("react");
var client_1 = require("@apollo/client");
var elasticsearch_1 = require("@elastic/elasticsearch");
var react_hooks_1 = require("@onemedical/react-hooks");
exports.GET_CREDENTIALS = client_1.gql(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n  query CredentialsQuery {\n    credentials: elasticsearchCredentials {\n      username\n      password\n    }\n  }\n"], ["\n  query CredentialsQuery {\n    credentials: elasticsearchCredentials {\n      username\n      password\n    }\n  }\n"])));
function useElasticsearch(query, _a) {
    var url = _a.url, prefix = _a.prefix, index = _a.index, _b = _a.lazy, lazy = _b === void 0 ? false : _b, _c = _a.size, size = _c === void 0 ? 10 : _c, _d = _a.onCompleted, onCompleted = _d === void 0 ? function () { } : _d, _e = _a.onError, onError = _e === void 0 ? function () { } : _e, _f = _a.variables, variables = _f === void 0 ? {} : _f;
    if (!url) {
        throw new Error('missing url option');
    }
    if (!index) {
        throw new Error('missing index option');
    }
    var run = react_1.useRef(!lazy);
    var apollo = client_1.useApolloClient();
    var onCompletedCallback = react_hooks_1.useEventCallback(onCompleted);
    var onErrorCallback = react_hooks_1.useEventCallback(onError);
    var _g = react_1.useState({ query: query, variables: variables }), input = _g[0], setInput = _g[1];
    var stringifiedQuery = react_1.useMemo(function () {
        return JSON.stringify(input.query, function (_, value) {
            if (typeof value === 'string') {
                var match = value.match(/\$(\w+)/);
                if (match) {
                    return input.variables[match[1]];
                }
            }
            return value;
        });
    }, [input]);
    var stringifiedIndex = JSON.stringify(index);
    function searchReducer(state, action) {
        switch (action.type) {
            case 'SEARCH_INIT':
                return tslib_1.__assign(tslib_1.__assign({}, state), { searching: true });
            default:
                return tslib_1.__assign(tslib_1.__assign(tslib_1.__assign({}, state), action.payload), { searching: false });
        }
    }
    var _h = react_1.useReducer(searchReducer, {
        searching: false
    }), output = _h[0], dispatch = _h[1];
    var search = react_hooks_1.useEventCallback(function (options) {
        if (options === void 0) { options = {}; }
        var updatedVars = typeof options.variables === 'function'
            ? options.variables(input.variables)
            : options.variables;
        setInput(function (prev) { return ({
            query: options.query || prev.query,
            variables: updatedVars || tslib_1.__assign({}, prev.variables)
        }); });
    });
    react_1.useEffect(function () {
        function elasticsearchClient(_a) {
            var username = _a.username, password = _a.password;
            var clientUrl = new URL(url);
            clientUrl.username = username || '';
            clientUrl.password = password || '';
            var accessToken = window.localStorage.getItem('auth:token');
            if (accessToken) {
                return new elasticsearch_1.Client({
                    node: { url: clientUrl },
                    headers: {
                        'X-Access-Token': accessToken
                    }
                });
            }
            return new elasticsearch_1.Client({
                node: { url: clientUrl }
            });
        }
        function init() {
            return tslib_1.__awaiter(this, void 0, void 0, function () {
                var idx, credentials, parsedQuery, response, results, total, error_1;
                return tslib_1.__generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            idx = JSON.parse(stringifiedIndex);
                            dispatch({ type: 'SEARCH_INIT' });
                            _a.label = 1;
                        case 1:
                            _a.trys.push([1, 4, , 5]);
                            return [4 /*yield*/, apollo.query({ query: exports.GET_CREDENTIALS })];
                        case 2:
                            credentials = (_a.sent()).data.credentials;
                            parsedQuery = void 0;
                            try {
                                parsedQuery = JSON.parse(stringifiedQuery);
                            }
                            catch (error) {
                                throw new Error('invalid query');
                            }
                            return [4 /*yield*/, elasticsearchClient(credentials).search({
                                    index: (Array.isArray(idx) ? idx : [idx]).map(function (i) { return "" + (prefix || '') + i; }),
                                    search_type: 'dfs_query_then_fetch',
                                    size: size,
                                    from: ((input.variables.page || 1) - 1) * size,
                                    body: parsedQuery
                                })];
                        case 3:
                            response = _a.sent();
                            results = response.body.hits.hits.map(function (hit) { return hit._source; });
                            total = response.body.hits.total;
                            dispatch({
                                type: 'SEARCH_SUCCESS',
                                payload: {
                                    results: results,
                                    total: total,
                                    aggregations: response.body.aggregations,
                                    suggest: response.body.suggest,
                                    size: size,
                                    page: input.variables.page,
                                    totalPages: Math.ceil(total / size)
                                }
                            });
                            onCompletedCallback({ results: results, total: total });
                            return [3 /*break*/, 5];
                        case 4:
                            error_1 = _a.sent();
                            console.error('[useElasticsearch]', error_1.message); // eslint-disable-line no-console
                            dispatch({ type: 'SEARCH_FAILURE', payload: { error: error_1 } });
                            onErrorCallback(error_1);
                            return [3 /*break*/, 5];
                        case 5: return [2 /*return*/];
                    }
                });
            });
        }
        if (run.current)
            init();
        run.current = true;
    }, [
        search,
        input,
        apollo,
        stringifiedQuery,
        stringifiedIndex,
        prefix,
        size,
        url,
        onCompletedCallback,
        onErrorCallback,
    ]);
    return [search, output];
}
exports["default"] = useElasticsearch;
var templateObject_1;
//# sourceMappingURL=useElasticsearch.js.map